import { hotlineConsultantReorderText } from '@/feature/hotline/client/detail/reorder/constant/text';
import { t } from '@/utils/constants/text/text';
import { z } from '@/utils/libs/zod/base';
const messages = t.validation;
const { label } = hotlineConsultantReorderText;
/**
 * 匿名コンサルホットライン 相談日程再度申し込みのスキーマ
 */
export const hotlineClientReorderFormSchemaBase = z.object({
    /**
     * 相談内容
     */
    description: z
        .string({ required_error: messages.required(label.description()) })
        .min(1, messages.required(label.description()))
        .max(10000, messages.maxLength(10000, label.description())),
    /**
     * 相談希望開始日
     */
    interviewRequestedFromAt: z.date({
        invalid_type_error: messages.format(label.interviewRequestedFromAt()),
        required_error: messages.requiredSelect(label.interviewRequestedFromAt()),
    }),
    /**
     * 相談希望終了
     */
    interviewRequestedToAt: z.date({
        invalid_type_error: messages.format(label.interviewRequestedToAt()),
        required_error: messages.requiredSelect(label.interviewRequestedToAt()),
    }),
});
/**
 * 匿名コンサルホットライン 投稿フォーム schema
 * @description 各 Field が optional な型
 */
export const hotlineClientReorderFormSchema = hotlineClientReorderFormSchemaBase.refine((data) => data.interviewRequestedToAt > data.interviewRequestedFromAt, {
    message: messages.requiredSelectPeriod(label.interviewRequestedFromAt(), label.interviewRequestedToAt()),
    path: ['interviewRequestedToAt'],
});
